import historyList from './list.vue';
export default {
  name: 'history-control-list',
  components: {
    historyList: historyList
  },
  props: {
    importTemplate: {
      default: function _default() {
        return false;
      }
    },
    id: {}
  }
};